import React, { useContext } from "react";
import { cutShort } from "../../../../utils/stringUtil";
import Box from "../../../../common/box/Box";
import { MessageContext } from "../../../../common/message";
import { useTranslation } from "react-i18next";
import { getAccessToken } from "../../../../common/authorization/AuthorizeService";

function RequestReviewItem({ state, label, href, fileName = "", attached = false }) {
  const message = useContext(MessageContext);
  const { t } = useTranslation();
  const wait = () =>
    message.toggle({
      title: "",
      content: t("requests.overview.submitted.wait.label"),
      hideX: false,
      hideYes: true,
      hideNo: true,
      isWait: true,
    });
  const closeAutomatically = () => {
    message.toggle({});
  };
  return (
    <Box statusIndicatorPosition={"left"} statusIndicatorColor={attached ? "green" : "grey"}>
      <div className="level ">
        <div className="level-left level-item is-flex-shrink-1">{label}</div>
        <div className="level-right">
          {attached && (
            <Box
              defaultPadding={false}
              isBorderless={true}
              isShadowless={true}
              className={"p-2 has-background-white-ter is-size-7 has-text-weight-bold is-link"}
              onClick={async () => {
                wait();
                fetch(
                  `${process.env.REACT_APP_GATEWAY_URL}/requests/${state.id}/submissions/${state.uid}/preview`,
                  {
                    method: "POST",
                    body: JSON.stringify(state),
                    headers: {
                      "Content-Type": "application/json",
                      "Request-Origin": "portal",
                      Authorization: "Bearer " + (await getAccessToken()),
                    },
                    mode: "cors",
                    credentials: "include",
                  }
                )
                  .then((response) => response.blob())

                  .then((pdf) => window.open(URL.createObjectURL(pdf)))
                  .then(closeAutomatically);
              }}
            >
              <a
                href={href}
                className="is-link has-text-grey-dark"
                rel="noopener noreferrer"
                //onClick=
                target="_blank"
              >
                {cutShort(fileName, 45, "...")}
              </a>
            </Box>
          )}
        </div>
      </div>
    </Box>
  );
}

export default RequestReviewItem;
